import { useState, useCallback, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import Layout from '@/components/Layout';
import Dashboard from '@/pages/Dashboard';
import TierList from '@/pages/TierList';
import UpgradeMatrix from '@/pages/UpgradeMatrix';
import AccessMatrix from '@/pages/AccessMatrix';
import CsiMap from '@/pages/CsiMap';
import Promotions from '@/pages/Promotions';
import SeedPage from '@/pages/SeedPage';
import SignIn from '@/pages/SignIn';
import { getAuth } from '@/services/auth';
import { loadAppConfig } from '@/config/api';
import { resetClient } from '@/services/adminApi';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!getAuth());
  const [configLoaded, setConfigLoaded] = useState(false);

  // Load runtime config (API base URL + API key) from /config.json
  useEffect(() => {
    loadAppConfig().then(() => {
      resetClient(); // Rebuild axios client with new config
      setConfigLoaded(true);
    });
  }, []);

  const handleAuthenticated = useCallback(() => {
    resetClient(); // Rebuild client to pick up new auth token
    setIsAuthenticated(true);
  }, []);

  if (!configLoaded) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <SignIn onAuthenticated={handleAuthenticated} />;
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="tiers" element={<TierList />} />
        <Route path="upgrade-matrix" element={<UpgradeMatrix />} />
        <Route path="access-matrix" element={<AccessMatrix />} />
        <Route path="csi-map" element={<CsiMap />} />
        <Route path="promotions" element={<Promotions />} />
        <Route path="seed" element={<SeedPage />} />
      </Route>
    </Routes>
  );
}
